<picture class="main-image" (click)="clickOnPicture()">
  <source
    [srcset]="(images + image) + '.webp'"
    type="image/webp">
  <img
    fetchpriority="high"
    loading="eager"
    [width]="width"
    [height]="height"
    [src]="(images + 'png/' + image) + '.png'"
    [title]="currentLang === 'ua' ? 'Дізнатися ціни та забронювати ' + name : 'Узнать цены и забронировать ' + name"
    [alt]="currentLang === 'ua' ? 'Ціни на ' + name : 'Цены на ' + name"
    [class.loaded]="imageLoaded"
    (load)="onImageLoad()">
</picture>
